import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
} from 'reactstrap';
import styles from './styles.module.scss';

export default function NewImageWithText({
    customClass = "",
    post
}) {
    return (
        <>
            <div className={`${styles.root} ${customClass}`}>
                <Container>
                    <div className="d-flex gap-5 flex-wrap">
                        {post.map((post, index) =>
                            <div className="item d-flex gap-5 flex-wrap flex-lg-nowrap w-100 align-items-center" key={index}>
                                <div className="column">
                                    <div dangerouslySetInnerHTML={{ __html: post.content }} />
                                    {post.buttonlink && (
                                        <a className="primaryBtn no-arrow" href={`${post.buttonlink}`}>{post.buttontitle}</a>
                                    )}
                                </div>
                                <div className="column">
                                    <SourceFlowImage
                                        src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="600x300"
                                        alt={`Image ${index}`}
                                        className="card-img"
                                        width="100%"
                                        height="100%"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </Container>
            </div>
        </>
    )
}